import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export function distinctUntilChangedObject() {
  return <T>(source: Observable<T>) => {
    return source.pipe(distinctUntilChanged((prevValue, nextValue) => JSON.stringify(prevValue) === JSON.stringify(nextValue)));
  };
}
